import { memo } from "react";
import CartItemSmall from "./CartItemSmall";
import { Product } from "@/types/product";
import { getProductVariantData } from "@/utils/get-product-variant-data";

type ProductListProps = {
  productList: Product[];
  onSelectProduct: (product: Product) => void;
};

export const ProductList = memo(function ProductList({
  productList,
  onSelectProduct,
}: ProductListProps) {
  if (!productList?.length) {
    return null;
  }

  return (
    <section
      className="nut-w-full nut-mb-4"
      aria-label="Product recommendations"
    >
      <div className="nut-flex nut-items-end nut-justify-between nut-mb-[10px] nut-px-[2px]">
        <div>
          <p className="nut-text-[15px] nut-font-bold nut-text-gray-900">
            Recommended for you
          </p>
          <p className="nut-text-[12px] nut-text-gray-500">
            Tap a product to compare details
          </p>
        </div>
        <span className="nut-text-[11px] nut-font-medium nut-text-[#6D5CE7] nut-bg-[#F2EFFF] nut-rounded-full nut-px-[9px] nut-py-[4px]">
          {productList.length} matches
        </span>
      </div>
      <div className="nut-w-full nut-flex nut-gap-[10px] nut-overflow-x-auto nut-pb-[8px] nut-snap-x">
        {productList.map((product, index) => {
          const variantId = product.variants?.length
            ? product.primary_variant_id
              ? product.variants.find(
                  (variant: Product["variants"][number]) =>
                    variant.id === product.primary_variant_id,
                )?.id
              : product.variants[0]?.id
            : product.id;

          return (
            <div
              key={product.id || index}
              className="nut-rounded-[16px] nut-flex nut-flex-col nut-items-center nut-min-w-[158px] nut-w-[158px] nut-snap-start"
            >
              <CartItemSmall
                key={variantId || product.id}
                product={product}
                onClick={onSelectProduct}
              />
            </div>
          );
        })}
      </div>
    </section>
  );
});
